import useSettingsMutation from './setting.mutations';
import { queryOptions, useQuery } from '@tanstack/react-query';
import SettingsService from './setting.service';
import { queryClient } from '@/lib/queryClient';

interface IUseSettings {
  // getSettings: any;
  updateSettings: any;
  isUpdatingSettings: any;
  setIsUpdatingSettings: any;
}

const useSettings = (agentId?: number): IUseSettings => {
  const { updateSettings, isUpdatingSettings, setIsUpdatingSettings } = useSettingsMutation();

  const settingsService = SettingsService();

  // const getSettings = useQuery<any>({
  //   queryKey: ['settings', agentId],
  //   queryFn: async () => {
  //     if (!agentId) return new Promise((resolve) => resolve(null));
  //     return new Promise(async (resolve) => {
  //       await settingsService
  //         .getSettingsByAgentId({
  //           agentId,
  //         })
  //         .then((res) => {
  //           resolve(res?.data);
  //         });
  //     });
  //   },
  //   enabled: !!agentId,
  // });

  return {
    // getSettings,
    updateSettings,
    isUpdatingSettings,
    setIsUpdatingSettings,
  };
};

export default useSettings;

export interface ISettings {
  agentId: number;
}

export const createUserSettingsOptions = (agentId: number) => {
  const settingsService = SettingsService();
  return queryOptions({
    queryKey: ['userSettings', agentId],
    queryFn: async ({ signal }) => {
      const response = await settingsService.getSettingsByAgentId({ agentId, signal });
      console.log(response)
      if (!response?.data) return null
      return response.data;
    },
    ...queryClient.defaultQueryOptions,
    enabled: (!!agentId),
  });
};